import { withStylePrefix } from '../common/withStylePrefix';
import { NavBarComponent, chameleonNavBarTemplate } from './NavBar';
import styles from './NavBar.styles.scss';
export const chameleonNavBarDefinition = {
    baseName: 'nav-bar',
    template: chameleonNavBarTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonNavBar = NavBarComponent.compose(chameleonNavBarDefinition);
